import { Modal, Collapse } from 'bootstrap5'
import axios from "axios";

window.TABS = window.TABS || {};
window.TABS.api = {
    host:                'https://api.tabs.no',
    authHost:            'https://vipps.tabs.no',
    version:             'v2',
    ownHosting:          false,
    officeId:            null,
    disableTABScss:      false,
    disableTWcss:        false,
    loadedSession:       false,
    validApiHosts:       [
        {
            host:   'https://api.tabs.no',
            region: 'no',
            locale: 'no',
        },
        {
            host:   'https://api.stroptima.se',
            region: 'sv',
            locale: 'sv',
        },
        {
            host:   'https://api.web.stroptima.se',
            region: 'sv',
            locale: 'sv',
        },
        {
            host:   'https://staging.web.tabs.no',
            region: 'no',
            locale: 'no',
        },
        {
            host:   'https://staging.w.stroptima.se',
            region: 'se',
            locale: 'se',
        },
        {
            host:   'https://web.tabs.wip',
            region: 'no',
            locale: 'no',
        },
        {
            host:   'https://web.optima.wip',
            region: 'se',
            locale: 'se',
        },

    ],
    opener:              null,
    loadedOutsideIframe: false,
    calendarLoaded:      false,
    isLoaded:            false,
    modal:               null,

    init: function (d, s) {
        // Some sites have multiple api.js included, so we ensure it's only initialized once
        if (window.isTABSinitialized) {
            return;
        }
        window.isTABSinitialized = true;

        console.log('api init', d, s)
        this.setProperties()
        this.addMessageEventListener()

        if (typeof window.officeId !== 'number') {
            // Notifiy that office id is missing from window
            console.warn('window.officeId not set.')
        }
        this.officeId = window.officeId;

        if (document.readyState !== 'loading') {
            TABS.api.loadApiResources();
        } else {
            document.addEventListener('DOMContentLoaded', TABS.api.loadApiResources);
        }
    },

    setProperties: function () {
        // Set host
        if (typeof window.apiHost === 'string') {
            this.host = window.apiHost;
        } else if (window.ownHosting === true) {
            const protocol = location.protocol;
            const slashes = protocol.concat('//');
            const port = window.location.port ? ':' + window.location.port : '';
            this.host = slashes.concat(window.location.hostname, port);
        } else {
            // Check apiHost based on where JS was loaded from
            const _this = this;
            this.validApiHosts.map(function (apiHost) {
                if (document.currentScript.src.indexOf(apiHost.host) === 0) {
                    _this.host = apiHost.host
                    TABS.translation.locale = apiHost.locale
                    TABS.translation.region = apiHost.region
                }
            })
        }

        // Set authHost
        if (typeof window.authHost === 'string') {
            this.authHost = window.authHost;
        }

        // Set disable css
        if (typeof window.disable_tabs_css === 'boolean') {
            this.disableTABScss = window.disable_tabs_css;
        }
        if (typeof window.disable_tw_css === 'boolean') {
            this.disableTWcss = window.disable_tw_css;
        }
    },

    loadApiResources: function () {
        TABS.translation.init()

        // Load custom booking modal css, if not explicitly defined not to
        if (!TABS.api.disableTABScss) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = TABS.api.getHost() + '/css/dist/api.min.css?v=1.47';
            document.head.appendChild(link);
        }

        TABS.api.loadApiElements();
    },

    loadApiElements: function () {
        if (window.officeId !== TABS.api.officeId && typeof window.officeId === 'number') {
            this.officeId = window.officeId;
        }
        TABS.calendar.init()
        document.querySelectorAll('div[id^=api-]').forEach(function (el) {
            const apiFunctionName = el.id.replace('api-', '')
            if (apiFunctionName === 'main') {
                return;
            }

            if (el.dataset['version']) {
                TABS.api.version = el.dataset['version']
            }

            const dataAttributes = el.dataset;
            let url = TABS.api.getEndPoint(apiFunctionName, dataAttributes.version || TABS.api.version, dataAttributes.officeId || TABS.api.officeId)
            url += Object.keys(dataAttributes).reduce(function (carry, key) {
                if (url.indexOf('&' + key + '=') > -1 || url.indexOf('?' + key + '=') > -1) {
                    return carry
                }
                return carry + '&' + key + '=' + (TABS.util.getUrlParameter(key) || String(dataAttributes[key]))
            }, '')

            const callback = el.getAttribute('onload');
            url += (apiFunctionName === 'calendar') ? '&callback=' + window.location.protocol + "//" + window.location.host + window.location.pathname : ''

            axios.get(url).then(response => {
                const html = response.data;
                TABS.analytics.triggerAnalyticsEvent(apiFunctionName, 'loaded');
                el.innerHTML = html;

                const accordion = document.querySelector('#tabs-accordion .collapse');
                if (accordion) {
                    new Collapse(accordion, { toggle: false });
                }
                document.querySelectorAll('.loader').forEach(loader => loader.style.display = 'none');

                if (callback !== undefined && typeof window[callback] === 'function') {
                    window[callback](el, apiFunctionName);
                }

                if (['shop', 'course'].indexOf(apiFunctionName) > -1) {
                    TABS.shop.init();
                }
                if (apiFunctionName === 'calendar') {
                    TABS.calendar.init();
                }
                if (apiFunctionName === 'shop') {
                    const el = document.getElementById('webshop');
                    if (el) {
                        TABS.webshop.init();
                    }
                }
            });
        })

        this.checkSession();
        this.isLoaded = true;

        if (TABS.api.inIframe()) {
            TABS.booking.request('iframe-detect', null, null, {
                referrer: document.referrer,
                url:      window.location.href,
                officeId: TABS.api.officeId,
            }, 5)
        }
    },

    ajaxRequest: function (options) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(options.type || 'GET', options.url);
            xhr.setRequestHeader('Content-Type', options.contentType || 'application/x-www-form-urlencoded');
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText);
                } else {
                    reject(xhr.statusText);
                }
            };
            xhr.onerror = () => reject(xhr.statusText);
            xhr.send(options.data || null);
        });
    },

    checkSession: function () {
        if (TABS.util.getUrlParameter('tabs_jwt')) {
            TABS.api.ajaxRequest({ url: TABS.api.getEndPoint('vipps/login/session') })
                .then(res => {
                    res = JSON.parse(res);
                    if (res.in_progress && !TABS.api.loadedSession) {
                        // Stop loading multiple modals if multiple api.js has been included
                        TABS.api.loadedSession = true;
                        if (res.data.type === 'course') {
                            TABS.api.loadCourse(null, res.data.course_id, res.data.class_id, res.data.office_id);
                        } else if (res.data.type === 'package') {
                            TABS.api.loadPackage(null, res.data.package_id, res.data.class_id);
                        } else if (res.data.type === 'lesson') {
                            TABS.api.loadLesson(res.data.class_id, res.data.product_id, res.data.teacher_id, res.data.start, res.data.end, res.data.office_id);
                        }

                        // Remove tabs_jwt from url
                        let currQueryString = window.location.search;
                        currQueryString = currQueryString.replace('?', '').split('&').map(function (item) {
                            if (item.indexOf('tabs_jwt') === -1) {
                                return item;
                            }
                            return '';
                        }).filter(item => item).join('&');
                        window.history.pushState({}, '', '?' + currQueryString);
                    }
                });
        }

        const paymentId = TABS.util.getUrlParameter('paymentId');
        if (paymentId) {
            TABS.api.ajaxRequest({ url: TABS.api.getEndPoint('payment/callback') })
                .then(res => {
                    TABS.api.openModal(res);
                });
        }
    },

    getEndPoint: function (path, version, officeId, format) {
        if (typeof version === 'undefined') {
            version = this.version
        }
        if (typeof officeId === 'undefined') {
            officeId = this.officeId
        }
        if (typeof format === 'undefined') {
            format = 'html'
        }

        let url = TABS.api.getHost() + '/api/' + version + '/' + path + '?format=' + format + '&officeId=' + officeId;
        const params = {
            courseId:    TABS.util.getUrlParameter('courseId'),
            classId:     TABS.util.getUrlParameter('classId'),
            locationId:  TABS.util.getUrlParameter('locationId'),
            productId:   TABS.util.getUrlParameter('productId'),
            groupBy:     TABS.util.getUrlParameter('groupBy'),
            expandedIds: TABS.util.getUrlParameter('expandedIds'),
            vippsToken:  TABS.util.getUrlParameter('tabs_jwt'),
            paymentId:   TABS.util.getUrlParameter('paymentId'),
        }
        if (TABS.util.getUrlParameter('preview') === '1') {
            params.preview = 1;
        }

        return Object.keys(params).reduce(function (carry, key) {
            if (!params[key]) {
                return url
            }

            return url += '&' + key + '=' + params[key]
        }, url)
    },

    getAuthHost:       function () {
        return this.authHost;
    },
    getReferer:        function () {
        if (window.top.location === window.location) {
            return window.location.href.split('?')[0];
        }
        if (window.callback) {
            return window.callback;
        }
        return window.location.href;
    },
    loadOptimaPackage: function (event, packageId, classId) {
        TABS.api.loadPackage(event, packageId, classId, true);
    },
    loadPackage:       function (event, packageId, classId, optima, officeId, callback) {
        if (event) {
            event.preventDefault();
        }
        if (officeId === undefined) {
            officeId = this.officeId;
        }

        const url = this.getHost()
            + '/api/' + this.version + (optima ? '/optima-booking' : '/booking')
            + '?format=html&office_id=' + officeId
            + '&package_id=' + packageId
            + '&class_id=' + classId;

        TABS.api.ajaxRequest({
            url:  url,
            type: 'GET'
        })
            .then(html => {
                if (callback) {
                    return callback(html);
                }
                TABS.api.openModal(html);


                TABS.analytics.triggerAnalyticsEvent('package', 'open', event.target.dataset.packageName);
            })
            .catch(res => {
                if (res.status === 404 && res.responseText.indexOf('modal') > -1) {
                    TABS.api.notFoundModal(res.responseText);
                }
            });

        return true;
    },

    notFoundModal: function (html) {
        TABS.api.openModal(html);
    },

    loadElearning: function (event, productId, classId, productType) {
        if (event) {
            event.preventDefault();
        }

        const url = this.getHost()
            + '/api/' + this.version + '/booking'
            + '?format=html&office_id=' + this.officeId
            + '&product_id=' + productId
            + '&class_id=' + classId
            + '&product_type=' + productType;

        TABS.api.ajaxRequest({
            url:  url,
            type: 'GET'
        })
            .then(html => {
                TABS.api.openModal(html);

                TABS.analytics.triggerAnalyticsEvent('elearning', 'open', event.target.dataset.productName);
            })
            .catch(res => {
                if (res.status === 404 && res.responseText.indexOf('modal') > -1) {
                    TABS.api.notFoundModal(res.responseText);
                }
            });

        return true;
    },

    loadBook: function (event, productId, classId, productType) {
        event.preventDefault();

        const url = this.getHost()
            + '/api/' + this.version + '/optima-booking'
            + '?format=html&office_id=' + this.officeId
            + '&product_id=' + productId
            + '&class_id=' + classId
            + '&product_type=' + productType;

        TABS.api.ajaxRequest({
            url:  url,
            type: 'GET'
        })
            .then(html => {
                TABS.api.openModal(html);

                TABS.analytics.triggerAnalyticsEvent('book', 'open', event.target.dataset.productName);
            })
            .catch(res => {
                if (res.status === 404 && res.responseText.indexOf('modal') > -1) {
                    TABS.api.notFoundModal(res.responseText);
                }
            });

        return true;
    },

    loadCourse: function (element, courseId, classId, courseOfficeId, callback) {
        if (typeof courseOfficeId === 'number') {
            this.officeId = courseOfficeId;
        }

        let officeId = this.officeId;

        if (!officeId && window.officeId !== TABS.api.officeId && typeof window.officeId === 'number') {
            officeId = window.officeId;
            this.officeId = officeId;
        }

        const vippsToken = TABS.util.getUrlParameter('tabs_jwt');
        const campaignCode = TABS.util.getUrlParameter('campaignCode');
        const preview = TABS.util.getUrlParameter('preview');

        const url = this.getHost()
            + '/api/' + this.version + '/courses'
            + '?format=html&officeId=' + officeId
            + (courseId ? ('&courseId=' + courseId) : '')
            + (classId ? ('&classId=' + classId) : '')
            + (preview ? ('&preview=' + preview) : '')
            + (vippsToken ? ('&vippsToken=' + vippsToken) : '')
            + (campaignCode ? ('&campaignCode=' + campaignCode) : '');

        TABS.api.ajaxRequest({
            url:  url,
            type: 'GET'
        })
            .then(html => {
                TABS.calendar.submitInProgress = false;
                if (callback) {
                    return callback(html);
                }
                TABS.api.openModal(html);
                TABS.analytics.triggerAnalyticsEvent('courses', 'open', element.dataset.courseName);
            })
            .catch(res => {
                if (res.status === 404 && res.responseText.indexOf('modal') > -1) {
                    TABS.api.notFoundModal(res.responseText);
                }
            });

        return true;
    },
    closeModal: function () {
        if (!TABS.api.modal) {
            const modals = document.querySelectorAll('.lgd-api-modal')
            modals.forEach(modal => modal.remove());
            const backdrops = document.querySelectorAll('.modal-backdrop')
            backdrops.forEach(backdrop => backdrop.remove());
            const body = document.body
            if (body) {
                body.classList.remove('modal-open');
                body.style.paddingRight = '';
                body.style.overflow = '';
            }
            
            return;
        }
        TABS.api.modal.hide();
    },
    openModal:  function (html) {
        TABS.api.closeModal();
        const modal = document.createElement('div');
        modal.className = 'tabs-modal kadmin-modal lgd-api-modal fade';
        modal.tabIndex = -1;
        modal.innerHTML = html;
        document.body.appendChild(modal);

        TABS.api.modal = new Modal(modal, {
            backdrop: 'static',
            keyboard: false,
        })
        modal.addEventListener('shown.bs.modal', function () {
            modal.querySelectorAll('.collapse').forEach(el => {
                console.log('collapse init', el)
                new Collapse(el, { toggle: false })
            });
        });
        TABS.api.modal.show();

        modal.addEventListener('hidden.bs.modal', function () {
            if (!modal.dataset.persist) {
                modal.remove();
            }
            TABS.api.modal = null;
        });

        setTimeout(() => {
            // Ensure opacity is set to 1 after modal is added to DOM
            // Some sites have css overridden for modal opacity, so we ensure it's set to 1
            document.querySelectorAll('.tabs-modal').forEach(el => el.style.opacity = '1')
        }, 1000)

        // Run all scripts in modal
        const scripts = modal.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
            const script = document.createElement('script');
            if (scripts[i].src) {
                script.src = scripts[i].src;
            } else {
                script.text = scripts[i].text;
            }
            document.head.appendChild(script).parentNode.removeChild(script);
        }
    },

    loadLessonCalendar: function (productId, classId, officeId) {
        TABS.api.officeId = officeId;
        TABS.booking.request('calendar', null, function (html) {
            TABS.api.openModal(html);
            TABS.analytics.triggerAnalyticsEvent('calendar', 'open');
            TABS.calendar.init();
        }, {
            product_id: productId,
            class_id:   classId,
            office_id:  officeId,
            modal:      true,
        })
    },

    loadLesson: function (classId, productId, teacherId, start, end, officeId) {
        TABS.booking.request('booking', null, function (html) {
            TABS.api.openModal(html);
            TABS.analytics.triggerAnalyticsEvent('lesson', 'open');
            TABS.calendar.submitInProgress = false;
        }, {
            teacher:    teacherId,
            start:      start,
            end:        end,
            product_id: productId,
            class_id:   classId,
            office_id:  officeId,
            officeId:   officeId,
            vippsToken: TABS.util.getUrlParameter('tabs_jwt'),
            preview:    TABS.util.getUrlParameter('preview'),
        }, false, function () {
            alert(TABS.$t('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.'));
            TABS.calendar.submitInProgress = false;
        })
    },

    loadOther: function (e, productId, classId, productType, officeId, callback) {
        if (e) {
            e.preventDefault();
        }
        if (officeId === undefined) {
            officeId = this.officeId;
        }
        const url = this.getHost()
            + '/api/' + this.version + '/booking'
            + '?format=html&office_id=' + officeId
            + '&product_id=' + productId
            + '&class_id=' + classId
            + '&product_type=' + productType;

        TABS.api.ajaxRequest({
            url:  url,
            type: 'GET'
        })
            .then(html => {
                if (callback) {
                    return callback(html);
                }
                TABS.api.openModal(html);

                TABS.analytics.triggerAnalyticsEvent('other-sale', 'open', e.target.dataset.productName);
            })
            .catch(res => {
                if (res.status === 404 && res.responseText.indexOf('modal') > -1) {
                    TABS.api.notFoundModal(res.responseText);
                }
            });

        return true;
    },

    getHost: function () {
        if (typeof window.apiHost !== 'undefined') {
            return window.apiHost;
        } else if (typeof window.ownHosting !== 'undefined' && window.ownHosting === true) {
            const protocol = location.protocol;
            const slashes = protocol.concat('//');
            const port = window.location.port ? ':' + window.location.port : '';
            return slashes.concat(window.location.hostname, port);
        }
        return this.host;
    },
    // Keep support for legacy TABS.api functions in case some api users utilize it
    postLoginForm:         function (el, e) {
        e.preventDefault()
        TABS.legacy.postLoginForm(el);
    },
    postResetPassForm:     function (el, e) {
        e.preventDefault()
        TABS.legacy.postResetPassForm(el)
    },
    resetPassForm:         function () {
        TABS.legacy.resetPassForm()
    },
    showBack:              function () {
        TABS.legacy.showBack()
    },
    postRegisterForm:      function (el, e) {
        e.preventDefault()
        TABS.legacy.postRegisterForm(el)
    },
    triggerAnalyticsEvent: function (endpointName, action, label, value) {
        TABS.analytics.triggerAnalyticsEvent(endpointName, action, label, value)
    },
    inIframe:              function () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    },
    // Adds eventlistener for events sent from iframe to main window
    addMessageEventListener() {
        if (!TABS.api.inIframe()) {
            window.addEventListener("message", (event) => {
                const iframes = document.querySelectorAll('iframe')
                let apiIframe;
                if (!iframes.length) {
                    return;
                }
                for (var i = 0; i < iframes.length; i++) {
                    if (iframes[i].contentWindow === event.source) {
                        apiIframe = iframes[i].contentWindow;
                        break;
                    }
                }

                if (event.data.eventName === 'api:check') {
                    // Verify api is loaded outside iframe
                    apiIframe.postMessage({
                        eventName: 'api:check:callback',
                    }, '*');
                    return;
                }
                if (event.data.eventName === 'swish:payment') {
                    window.location.href = event.data.swishPaymentDeeplink

                    apiIframe.postMessage({
                        eventName: 'swish:payment:cancelErrorTimeout',
                    }, '*');
                }
            }, false)
        } else {
            window.addEventListener("message", (event) => {
                if (event.data.eventName === 'swish:payment:cancelErrorTimeout') {
                    window.clearTimeout(window.triggerSwishFailedTimeout)
                }
                if (event.data.eventName === 'api:check:callback') {
                    TABS.api.loadedOutsideIframe = true
                }
            }, false)

            window.top.postMessage({
                eventName: 'api:check',
            }, '*');
        }
    },
    toggleReadMore(index) {
        document.getElementById('readless-' + index).style.display = 'none';
        document.getElementById('readmore-' + index).style.display = 'block';
    },

    toggleReadLess(index) {
        document.getElementById('readless-' + index).style.display = 'block';
        document.getElementById('readmore-' + index).style.display = 'none';
    },
}